import { render, staticRenderFns } from "./MultiplasFaixas.vue?vue&type=template&id=5b919612&scoped=true&"
import script from "./MultiplasFaixas.vue?vue&type=script&lang=js&"
export * from "./MultiplasFaixas.vue?vue&type=script&lang=js&"
import style0 from "./MultiplasFaixas.vue?vue&type=style&index=0&id=5b919612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b919612",
  null
  
)

export default component.exports